<template>
    <main class="container">
        <h1>Connecting Bluetooth</h1>

        <section>
            <h2>Requirements:</h2>
            <ul>
                <li>
                    Bluetooth enabled phone/tablet or laptop, for Apple/IOS please install and use
                    <a href="https://apps.apple.com/us/app/bluefy-web-ble-browser/id1492822055" target="_blank">
                        the Buefy browser
                    </a>
                    for Apple based products
                </li>
                <li>
                    Number of the GoMonitor. You will find the number to connect to on the box.
                </li>
            </ul>

            <div class="alert alert-warning">
                <i class="alert-icon fa fa-info-circle fa-2x"></i>After the GoMonitor is powered on it may take a few
                minutes before the device is ready for Bluetooth connections
            </div>
        </section>
        <div class="row">
            <div class="col-2">
                <button class="btn btn-dark btn-lg" @click="router.go(-1)">
                    <i class="fas fa-arrow-left"></i>
                </button>
            </div>
            <div class="col-10">
                <button class="btn btn-dark btn-lg" @click="connect">
                    Connect
                </button>
            </div>
        </div>
    </main>
</template>

<script setup>
import { inject } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const GoConnect = inject('GoConnect');

function connect() {
    GoConnect.connect()
        .then(() => {
            router.push({ path: '/setup/3' });
        }).catch((error) => {
            /**
             * @todo Display error
             */
            GoConnect.handleError('error', error);
        });
}

</script>
